import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Tooltip } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import * as React from 'react';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { getRequestID } from '../../shared/util/request';
import RichTextField from '../../shared/util/richTextField/containers/richTextField';
const DEFAULT_MAX_MESSAGE_LENGTH = 50000;
export default class NoteForm extends React.Component {
    constructor(props) {
        super(props);
        this.setValidationState = (validation) => {
            this.setState({ validation });
        };
        this.handleSubmit = () => {
            this.setValidationState({ touched: true, valid: true });
            const text = this.editorRef.current.getText();
            if (text && typeof text === 'string' && text.trim() !== '') {
                if (text.length > DEFAULT_MAX_MESSAGE_LENGTH) {
                    this.setValidationState({
                        touched: true,
                        valid: false,
                        error: { type: 'length' },
                    });
                    return undefined;
                }
                const { csid, agentId, conversationSaveTempWrapup, conversationAddWrapup, } = this.props;
                const requestID = getRequestID();
                conversationAddWrapup({
                    requestID: requestID,
                    csid: csid,
                    note: text,
                    agentId: agentId,
                });
                this.editorRef.current.setText('');
                conversationSaveTempWrapup(csid, '');
                return false;
            }
            this.setValidationState({
                touched: true,
                valid: false,
                error: { type: 'required' },
            });
            return undefined;
        };
        this.renderTemplate = (payload) => {
            const { content } = payload;
            if (!content) {
                return Promise.reject('No content given');
            }
            return this.props.templatesRender({
                csid: this.props.csid,
                content: content && typeof content === 'string' ? content : '',
            });
        };
        this.state = {
            validation: { touched: false, valid: false },
        };
        this.editorRef = React.createRef();
    }
    componentDidMount() {
        this.loadTempValue();
        this.editorRef.current.focus();
    }
    componentDidUpdate(prevProps) {
        const { csid } = this.props;
        if (csid !== prevProps.csid) {
            this.saveTempValue(prevProps.csid);
            this.loadTempValue();
        }
    }
    componentWillUnmount() {
        const { csid } = this.props;
        this.saveTempValue(csid);
    }
    loadTempValue() {
        const { tempWrapup } = this.props;
        if (this.editorRef && this.editorRef.current) {
            this.editorRef.current.setText(tempWrapup);
        }
    }
    saveTempValue(csid) {
        const { conversationSaveTempWrapup } = this.props;
        if (this.editorRef && this.editorRef.current) {
            const textContent = this.editorRef.current.getText();
            if (typeof textContent === 'string') {
                conversationSaveTempWrapup(csid, textContent.trim());
            }
        }
    }
    render() {
        const rootClass = classnames({
            'conversation-form': true,
        }, this.props.className);
        const tooltipContent = (_jsx(CommandKeybindingsTooltipContent, Object.assign({ commandName: "richTextEditor:send" }, { children: "Add internal note" })));
        return (_jsxs("div", Object.assign({ className: rootClass }, { children: [_jsx("div", Object.assign({ className: "conversation-form__editorwrap" }, { children: _jsx(RichTextField, { className: "conversation-form__editornew", ref: this.editorRef, renderTemplate: this.renderTemplate, channel: "notes", placeholder: "Type your internal note", onTriggerSend: () => this.handleSubmit(), validation: this.state.validation, setValidationState: this.setValidationState }) })), _jsx("div", Object.assign({ className: "conversation-form__submit" }, { children: _jsx(Tooltip, Object.assign({ dark: true, content: tooltipContent, wrap: "div" }, { children: _jsx(Button, Object.assign({ type: "button", onClick: () => this.handleSubmit() }, { children: "Add note" })) })) }))] })));
    }
}
